<template>
<div class="ee-upload">
  <div @click="handleOpenFile" :style="style" title="点击上传" class="ee-upload__hot">
    <img v-if="path" :src="path" alt="">
    <i v-else :class="`text-icon icon-${icon}`"></i>
    <input @change="handleChange" ref="file" type="file">
  </div>
  <div class="ee-upload__desc">
    <slot></slot>
  </div>
</div>
</template>
<script>
  export default {
    compName: 'ee-upload',
    props: {
      width: Number,
      height: Number,
      value: [String, Number],
      imgUrl: String,
      name: {
        type: String,
        default: 'file'
      },
      fileType: String,
      icon: {
        type: String,
        default: 'add'
      }
    },
    data () {
      return {
        path: this.imgUrl,
        style: {
          width: `${this.width}px`,
          height: `${this.height}px`
        }
      }
    },
    watch: {
      imgUrl () {
        this.path = this.imgUrl
      }
    },
    methods: {
      handleOpenFile () {
        this.$refs.file.click()
      },
      handleChange () {
        const data = new FormData()
        const file = this.$refs.file.files[0]
        if (file) {
          data.append(this.name, file)
          this.$store.dispatch('uploadFile', data)
            .then(({path, fileName}) => {
              this.path = path
              this.$emit('input', fileName)
            })
            .catch(err => console.error(err))
        } else {
          this.$emit('input', '')
        }
      }
    }
  }
</script>
<style>
@component-namespace ee {
  @b upload {
    display: inline-block;
    @e hot {
      cursor: pointer;
      position: relative;
      margin: 0 auto;
      background-color: rgba(225, 225, 225, .21);
      border: 1px solid #eee;
      input {
        display: none;
      }
      .text-icon,
      img {
        position: absolute;
        top: 50%;
        left: 50%;
        transform: translateX(-50%) translateY(-50%);
      }
      .text-icon {
        font-size: 60px;
        color: #eee;
      }
      img {
        max-width: 100%;
        max-height: 100%;
      }
    }
    @e desc {
      text-align: center;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/packages/upload/Upload.vue?7ad70976